import type { HelpFile } from '../../types/help'
import { OnboardingWizardTestIds } from '../../../testids/OnboardingWizardTestIds'

export const onboardingWizardHelp: HelpFile = {
  docPage: '/docs/onboarding/wizard',
  texts: {
    [OnboardingWizardTestIds.onboardingWizardPage]: 'Step-by-step wizard to onboard a new party and identity — identifiers, attributes, and relationships.',
    [OnboardingWizardTestIds.btnNext]: 'Advance to the next step — required fields on the current step are validated first.',
    [OnboardingWizardTestIds.btnPrevious]: 'Return to the previous step — entered data is preserved.',
    [OnboardingWizardTestIds.btnCancel]: null,
    [OnboardingWizardTestIds.btnSubmit]: null,
  },
}
